var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary"},on:{"click":function($event){return _vm.handleNextState()}}},[_vm._v(" "+_vm._s(_vm.stateTextMap[this.gameState])+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }